export const MILESTONES = [25, 50, 75, 100];

export function goalPct(progress, goal) {
  return goal ? Math.min(100, Math.round(((progress || 0) / goal) * 100)) : 0;
}

export function milestoneMsg(pct) {
  if (pct >= 100) return "Goal smashed — thank you!";
  if (pct >= 75) return "So close · 75% funded!";
  if (pct >= 50) return "Halfway there!";
  if (pct >= 25) return "25% funded · momentum building!";
  return null;
}

export function highestMilestone(pct) {
  let m = 0;
  for (const t of MILESTONES) if (pct >= t) m = t;
  return m;
}

export function deadlineInfo(deadline) {
  if (!deadline) return null;
  const end = new Date(deadline).getTime();
  if (Number.isNaN(end)) return null;
  const now = Date.now();
  const ended = now > end;
  const daysLeft = Math.ceil((end - now) / 86400000);
  let label;
  if (ended) label = "Goal ended";
  else if (daysLeft <= 0) label = "Ends today";
  else if (daysLeft === 1) label = "1 day left";
  else label = `${daysLeft} days left`;
  return { ended, daysLeft, label, end };
}

export const money = (c) => `$${((c || 0) / 100).toFixed(2)}`;
